<template>
  <div>
    <!-- {{ scope.row.orderId }} -->
    <el-table :data="contactHistory" style="width: 100%" :render-header="renderHeader" height="calc(100vh - 353px)"
      @sort-change="handleSort" :row-class-name="tableRowClassName">
      <el-table-column prop="id" label="任务ID" align="left" width="80">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column prop="taskBelongTo" label="任务所属" align="center" min-width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.taskBelongTo === 'Fisher'">新手任务</span>
          <span v-if="scope.row.taskBelongTo === 'LimitedTime'">限时任务</span>
          <span v-if="scope.row.taskBelongTo === 'Standing'">常设任务</span>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="名称" align="center" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="任务内容" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="symbol"
        label="逻辑"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.symbol }}
        </template>
      </el-table-column> -->

      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未激活</span>
          <span v-if="scope.row.status == 1">激活</span>
          <span v-if="scope.row.status == 2">结算中</span>
          <span v-if="scope.row.status == 3">过期</span>
        </template>
      </el-table-column>

      <el-table-column prop="endTime" label="修改时间" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.updatedTime | moment }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="mini" @click="copy(scope.row)"
            >复制</el-button
          > -->
          <el-button size="mini" type="text" @click="handleView(scope.row)" v-if="
            $hasPerm('tenant:activity_task_mgmt:view')
          ">查看</el-button>
          <el-button v-if="
            $hasPerm('tenant:activity_task_mgmt:put_on_shelf') &&
            compareTime(scope.row)
          " size="mini" type="text" @click="handleActive(scope.row)">上架
          </el-button>
          <el-button v-if="
            $hasPerm('tenant:activity_task_mgmt:put_off_shelf') &&
            scope.row.listingStatus
          " size="mini" type="text" @click="handleActive(scope.row)">下架</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
      </pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <Add ref="detailDialog" mode="view" :show-trigger="false" />
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import Add from '../add'
import order from '@/assets/order.png'
import copyImg from '@/assets/copy.png'
import moment from 'moment'
import UserDetailDialog from 'components/userDetailDialog'

import tip from '@/assets/partnerCenter/tip.png'
export default {
  name: 'ManagementList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      order,
      tip,
      copyImg,
      type: '',
      id: '',
      cacheRow: {},
      orderList: [],

      orderPage: {
        page: 1,
        size: 10,
      },
      orderTotal: 0,
    }
  },
  components: {
    Pagination,
    UserDetailDialog,
    updateDialog,
    Add,
  },
  methods: {
    ...mapMutations('management', ['setPagination', 'setOrderBy']),
    ...mapActions('management', ['getActive']),
    // getContactHistory() {

    //   this.getHistory()
    // },
    renderHeader(h, { column, $index }) {
      // 新建一个 span
      let span = document.createElement('span')
      // 设置表头名称
      span.innerText = column.label
      // 临时插入 document
      document.body.appendChild(span)
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20
      // 移除 document 中临时的 span
      document.body.removeChild(span)
      return h('span', column.label)
    },
    compareTime(row) {
      if (!row.listingStatus) {
        //startTime小于当前时间 就不展示上架按钮
        return row.startTime > moment().valueOf()
      }
    },
    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },
    pageChanged(pagination) {
      this.setPagination(pagination)
      this.$emit('refresh', { ...pagination })
    },
    handleView(row) {
      this.$refs.detailDialog.openDetail(row)
    },
    handleActive(row) {
      const message = row.listingStatus ? '是否下架' : '是否上架'
      this.$confirm(message, '提示', {
        type: 'warning',
      }).then(() => {
        this.getActive({
          id: row.id,
          tenantId: -1,
          listingStatus: !row.listingStatus,
        }).then(() => {
          this.$message.success('设置成功！')
          this.$emit('refresh')
        })
      })
    },

    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },

    handleSort({ column, prop, order }) {
      this.setOrderBy(null)
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },

    tableRowClassName({ row }) {
      if (row.mark == true) {
        return 'redRow'
      }
      return ''
    },
  },
  computed: {
    // ...mapGetters('user', ['contactHistory']),
    ...mapState(['userInfo']),
    ...mapState('management', [
      'pagination',
      'contactHistory',
      'totalCount',
      'orderBy',
    ]),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.green {
  color: skyblue;
}

.red {
  color: #f54a45;
}
</style>
